import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Wrapper from './Wrapper';

function PerspectiveDemo({ perspective }) {
  return (
    <Wrapper style={{ perspective: `${perspective}px` }}>
      <Box />
      <Code>perspective: {perspective}px;</Code>
    </Wrapper>
  );
}

const Code = styled.code`
  font-size: 1rem;
  font-family: var(--font-family-mono);
`;

const Box = styled.div`
  width: 120px;
  height: 120px;
  background: var(--color-primary);
  animation: perspectiveSpin 2000ms ease-in-out alternate infinite;
  will-change: transform;

  @keyframes perspectiveSpin {
    from {
      transform: rotateY(-45deg);
    }
    to {
      transform: rotateY(45deg);
    }
  }
`;

export default PerspectiveDemo;
